// Provider health and the general dispatch permission are separate facts.
export function emailStatusKey(result) {
  if (!result) return null;
  if (result.status !== "active") return result.status || "error";
  if (result.transactional_enabled === true) return "enabled";
  if (result.transactional_enabled === false) return "disabled";
  return "unconfirmed";
}
